import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ContentListContainer} from '../../core/definitions/object-content-tab/content-list-container';
import {SearchExecutorService} from '../../object-search/search-executor.service';
import {SearchResultViewType} from '../../core/definitions/search-result-view-type.enum';
import {applyContentListView} from '../content-list-view';

@Component({
    selector: 'app-object-content-list-regular',
    templateUrl: './object-content-list-regular.component.html',
    styleUrls: ['./object-content-list-regular.component.scss'],
    standalone: false
})
export class ObjectContentListRegularComponent {
  private readonly searchExecutorService: SearchExecutorService = inject(SearchExecutorService);

  @Input() contentListContainer: ContentListContainer;
  @Output() objectRefresh = new EventEmitter<any>();

  selectView(viewName: SearchResultViewType) {
    if (!this.contentListContainer || this.contentListContainer.resultViewName === viewName) {
      return;
    }
    this.contentListContainer.resultViewName = viewName;
    applyContentListView(this.contentListContainer.searchContainer, viewName);
    this.searchExecutorService.runSearch(this.contentListContainer.searchContainer).then();
  }

  setObjectRefresh(event) {
    this.objectRefresh.emit(event);
  }

  onContentChange(event) {
    console.log('Event performed: ' + event);
  }
  get disabled() {
    let res = this.contentListContainer.operationContainer.art.read_only;
    if (!res) {
      const selections = this.contentListContainer.searchContainer.selections;
      res = !(selections.allSelected || !!selections.selectedItems.length);
    }
    return res;
  }
}
